import {createSelector} from 'reselect';

import {RootState} from 'ducks';
import {RootState as QuotingRootState} from 'ducks/Quoting';
import {State as SessionActivityState} from 'ducks/SessionActivity';

const getSessionActivityState = (state: RootState | QuotingRootState): SessionActivityState => state.sessionActivity;

export const getLastActivityTimestamp = createSelector(
  getSessionActivityState,
  (sessionActivityState: SessionActivityState): number => sessionActivityState.lastActivityTimestamp
);

export const shouldShowTimeoutWarning = createSelector(
  getSessionActivityState,
  (sessionActivityState: SessionActivityState) => sessionActivityState.showTimeoutWarning
);
